// extracted by mini-css-extract-plugin
export default {"container":"perks-block-module__container___SlwOJ","title":"perks-block-module__title___Svz_d","noBorder":"perks-block-module__noBorder___ldCb6"};